// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"6a1c77d3","308":"8d7db516","360":"e28ebde3","536":"c2f83a32","735":"2ca21ec7"}[chunkId] + ".chunk.js";
};